// ========== Common Icons ==========
import userIcon from '../assets/icons/user-icon.png';
import exitIcon from '../assets/icons/icon-exit.png';
import textIcon from '../assets/icons/icon-text.png';
import settingsIcon from '../assets/icons/icon-settings.png';
import soundIcon from '../assets/icons/icon-sound.png';
import soundOffIcon from '../assets/icons/icon-sound-off.png';
import plusIcon from '../assets/icons/plus-icon.png';
import arrowIcon from '../assets/icons/arrow-icon.svg';
import dropdownBackground from '../assets/icons/dropdown-menu-background.png';
import qrScanIcon from '../assets/icons/qr-scan-icon.svg';
import copyIcon from '../assets/icons/copy-icon.png';
import editIcon from '../assets/icons/edit-icon.svg';
import eyeIcon from '../assets/icons/eye-icon.svg';
import checkmarkIcon from '../assets/icons/checkmark-icon.svg';
import replayIcon from '../assets/icons/replay-icon.png';
import exitIconN from '../assets/icons/exit-icon.png';

import playerCardBg from '../assets/icons/PlayerCardBackground.png';
import homeCardBg from '../assets/icons/homeCardBackground.png';
import buttonBg from '../assets/icons/button-background.png';
import playerAvatarBg from '../assets/icons/PlayerAvatarBackground.png';

import dealerIcon from '../assets/icons/dealer-icon.svg';
import scoreIcon from '../assets/icons/score-icon.svg';
import tokenRed from '../assets/icons/token-red.png';
import tokenYellow from '../assets/icons/token-yellow.png';
import tokenGreen from '../assets/icons/token-green.png';
import standardBet from '../assets/icons/standard-bet.png';
import betPro from '../assets/icons/bet_pro.png';
import betFree from '../assets/icons/bet_free.png';
import betExpert from '../assets/icons/bet_expert.png';
import sliderHandle from '../assets/icons/slider-handle.png';

import endGameBg from '../assets/icons/EndGameBackground.png';
import endGameBgWin from '../assets/icons/EndGameBackgroundWin.png';
import endGameBgX from '../assets/icons/EndGameBackgroundX.png';

import usdtIcon from '../assets/icons/usdt-icon.png';
import usdtSvg from '../assets/icons/usdt.svg';
import starIcon from '../assets/icons/star-icon.png';
import trxIcon from '../assets/icons/trx.svg';
import tonIcon from '../assets/icons/ton.svg';
import telegramIcon from '../assets/icons/telegram-icon.svg';

import hearts from '../assets/icons/hearts.svg';
import diamonds from '../assets/icons/diamonds.svg';
import clubs from '../assets/icons/clubs.svg';
import spades from '../assets/icons/spades.svg';
import anxoz from '../assets/icons/anxoz.svg';

import trpOn from '../assets/icons/trpOn.png';
import trp from '../assets/icons/trp.png';


// ========== Game Logos ==========
import rpsLogo from '../assets/home/RPS-logo.png';
import blotLogo from '../assets/home/Blot-logo.png';
import carromLogo from '../assets/home/Carrom-logo.png';
import backgammonLogo from '../assets/home/backgammon-logo.png';
import pokerLogo from '../assets/home/Poker-logo.png';
import dominoLogo from '../assets/home/RPS-logo.png';


// ========== Home Page Assets ==========
import medal from '../assets/home/medal.svg';
import home from '../assets/home/home.png';
import coins from '../assets/home/coins.svg';
import tasks from '../assets/home/tasks.png';
import friends from '../assets/home/friends.png';
import trophy from '../assets/home/trophy.svg';
import avatarIcon from '../assets/home/avatar-icon.svg';
import more from '../assets/home/more.png';
import smile from '../assets/home/smile.svg';
import gameCard from '../assets/home/gameCard.png';
import settingIcon from '../assets/home/setting-icon.svg';


import chipRed from '../assets/pokerAssets/chip_red.png';

// ========== Blot Game Assets ==========

import cardBack from '../assets/cards/card_back.png';
import sevenOfHearts from '../assets/cards/7_of_hearts.png';
import sevenOfDiamonds from '../assets/cards/7_of_diamonds.png';
import sevenOfClubs from '../assets/cards/7_of_clubs.png';
import sevenOfSpades from '../assets/cards/7_of_spades.png';
import eightOfHearts from '../assets/cards/8_of_hearts.png';
import eightOfDiamonds from '../assets/cards/8_of_diamonds.png';
import eightOfClubs from '../assets/cards/8_of_clubs.png';
import eightOfSpades from '../assets/cards/8_of_spades.png';
import nineOfHearts from '../assets/cards/9_of_hearts.png';
import nineOfDiamonds from '../assets/cards/9_of_diamonds.png';
import nineOfClubs from '../assets/cards/9_of_clubs.png';
import nineOfSpades from '../assets/cards/9_of_spades.png';
import tenOfHearts from '../assets/cards/10_of_hearts.png';
import tenOfDiamonds from '../assets/cards/10_of_diamonds.png';
import tenOfClubs from '../assets/cards/10_of_clubs.png';
import tenOfSpades from '../assets/cards/10_of_spades.png';
import jackOfHearts from '../assets/cards/J_of_hearts.png';
import jackOfDiamonds from '../assets/cards/J_of_diamonds.png';
import jackOfClubs from '../assets/cards/J_of_clubs.png';
import jackOfSpades from '../assets/cards/J_of_spades.png';
import queenOfHearts from '../assets/cards/Q_of_hearts.png';
import queenOfDiamonds from '../assets/cards/Q_of_diamonds.png';
import queenOfClubs from '../assets/cards/Q_of_clubs.png';
import queenOfSpades from '../assets/cards/Q_of_spades.png';
import kingOfHearts from '../assets/cards/K_of_hearts.png';
import kingOfDiamonds from '../assets/cards/K_of_diamonds.png';
import kingOfClubs from '../assets/cards/K_of_clubs.png';
import kingOfSpades from '../assets/cards/K_of_spades.png';
import aceOfHearts from '../assets/cards/A_of_hearts.png';
import aceOfDiamonds from '../assets/cards/A_of_diamonds.png';
import aceOfClubs from '../assets/cards/A_of_clubs.png';
import aceOfSpades from '../assets/cards/A_of_spades.png';





// ========== RPS Game Assets ==========
import rock from '../assets/rpsAssets/rock.png';
import paper from '../assets/rpsAssets/paper.png';
import scissors from '../assets/rpsAssets/scissors.png';
import stars from '../assets/rpsAssets/stars.png';


// ========== Carrom Game Assets ==========
import boardBackground from '../assets/carromAssets/board-background.png';
import boardBorder from '../assets/carromAssets/board-border.png';
import boardLines from '../assets/carromAssets/board-lines.png';
import striker from '../assets/carromAssets/striker.png';
import whiteCoin from '../assets/carromAssets/white-coin.png';
import blackCoin from '../assets/carromAssets/black-coin.png';
import queenCoin from '../assets/carromAssets/queen-coin.png';
import whiteCoinS from '../assets/carromAssets/white-coinS.png';
import blackCoinS from '../assets/carromAssets/black-coinS.png';
import queenCoinS from '../assets/carromAssets/queen-coinS.png';
import star from '../assets/carromAssets/star.png';
import controller from '../assets/carromAssets/carrom-Contraller.png';


// ========== Backgammon Game Assets ==========
import board from '../assets/backgammonAssets/board.png';
import checkerwhite from '../assets/backgammonAssets/checker-white.png';
import checkerblack from '../assets/backgammonAssets/checker-black.png';
import dice1 from '../assets/backgammonAssets/dice-1.png';
import dice2 from '../assets/backgammonAssets/dice-2.png';
import dice3 from '../assets/backgammonAssets/dice-3.png';
import dice4 from '../assets/backgammonAssets/dice-4.png';
import dice5 from '../assets/backgammonAssets/dice-5.png';
import dice6 from '../assets/backgammonAssets/dice-6.png';
import opponentDice1 from '../assets/backgammonAssets/OpponentDice-1.png';
import opponentDice2 from '../assets/backgammonAssets/OpponentDice-2.png';
import opponentDice3 from '../assets/backgammonAssets/OpponentDice-3.png';
import opponentDice4 from '../assets/backgammonAssets/OpponentDice-4.png';
import opponentDice5 from '../assets/backgammonAssets/OpponentDice-5.png';
import opponentDice6 from '../assets/backgammonAssets/OpponentDice-6.png';
import voidButton from '../assets/backgammonAssets/void-button.png';
import confirmButton from '../assets/backgammonAssets/confirm-button.png';
import rollDiceButton from '../assets/backgammonAssets/roll-dice-button.png';
import waitingButton from '../assets/backgammonAssets/waiting-button.png';
import moveBlocked from '../assets/backgammonAssets/move-blocked.png';
import whiteCheckerX from '../assets/backgammonAssets/whiteCheckerX-icon.png';
import blackCheckerX from '../assets/backgammonAssets/blackCheckerX-icon.png';

import welcomeImage1 from '../assets/welcome/welcome1.png';
import welcomeImage2 from '../assets/welcome/welcome2.png';
import welcomeImage3 from '../assets/welcome/welcome3.png';
import welcomeImage4 from '../assets/welcome/welcome4.png';
import welcomeImage5 from '../assets/welcome/welcome5.png';





// ========== Poker Game Assets ==========


import p_twoOfHearts from '../assets/p-cards/2_of_hearts.png';
import p_twoOfDiamonds from '../assets/p-cards/2_of_diamonds.png';
import p_twoOfClubs from '../assets/p-cards/2_of_clubs.png';
import p_twoOfSpades from '../assets/p-cards/2_of_spades.png';

import p_threeOfHearts from '../assets/p-cards/3_of_hearts.png';
import p_threeOfDiamonds from '../assets/p-cards/3_of_diamonds.png';
import p_threeOfClubs from '../assets/p-cards/3_of_clubs.png';
import p_threeOfSpades from '../assets/p-cards/3_of_spades.png';

import p_fourOfHearts from '../assets/p-cards/4_of_hearts.png';
import p_fourOfDiamonds from '../assets/p-cards/4_of_diamonds.png';
import p_fourOfClubs from '../assets/p-cards/4_of_clubs.png';
import p_fourOfSpades from '../assets/p-cards/4_of_spades.png';

import p_fiveOfHearts from '../assets/p-cards/5_of_hearts.png';
import p_fiveOfDiamonds from '../assets/p-cards/5_of_diamonds.png';
import p_fiveOfClubs from '../assets/p-cards/5_of_clubs.png';
import p_fiveOfSpades from '../assets/p-cards/5_of_spades.png';

import p_sixOfHearts from '../assets/p-cards/6_of_hearts.png';
import p_sixOfDiamonds from '../assets/p-cards/6_of_diamonds.png';
import p_sixOfClubs from '../assets/p-cards/6_of_clubs.png';
import p_sixOfSpades from '../assets/p-cards/6_of_spades.png';


import p_sevenOfHearts from '../assets/p-cards/7_of_hearts.png';
import p_sevenOfDiamonds from '../assets/p-cards/7_of_diamonds.png';
import p_sevenOfClubs from '../assets/p-cards/7_of_clubs.png';
import p_sevenOfSpades from '../assets/p-cards/7_of_spades.png';
import p_eightOfHearts from '../assets/p-cards/8_of_hearts.png';
import p_eightOfDiamonds from '../assets/p-cards/8_of_diamonds.png';
import p_eightOfClubs from '../assets/p-cards/8_of_clubs.png';
import p_eightOfSpades from '../assets/p-cards/8_of_spades.png';
import p_nineOfHearts from '../assets/p-cards/9_of_hearts.png';
import p_nineOfDiamonds from '../assets/p-cards/9_of_diamonds.png';
import p_nineOfClubs from '../assets/p-cards/9_of_clubs.png';
import p_nineOfSpades from '../assets/p-cards/9_of_spades.png';
import p_tenOfHearts from '../assets/p-cards/10_of_hearts.png';
import p_tenOfDiamonds from '../assets/p-cards/10_of_diamonds.png';
import p_tenOfClubs from '../assets/p-cards/10_of_clubs.png';
import p_tenOfSpades from '../assets/p-cards/10_of_spades.png';
import p_jackOfHearts from '../assets/p-cards/J_of_hearts.png';
import p_jackOfDiamonds from '../assets/p-cards/J_of_diamonds.png';
import p_jackOfClubs from '../assets/p-cards/J_of_clubs.png';
import p_jackOfSpades from '../assets/p-cards/J_of_spades.png';
import p_queenOfHearts from '../assets/p-cards/Q_of_hearts.png';
import p_queenOfDiamonds from '../assets/p-cards/Q_of_diamonds.png';
import p_queenOfClubs from '../assets/p-cards/Q_of_clubs.png';
import p_queenOfSpades from '../assets/p-cards/Q_of_spades.png';
import p_kingOfHearts from '../assets/p-cards/K_of_hearts.png';
import p_kingOfDiamonds from '../assets/p-cards/K_of_diamonds.png';
import p_kingOfClubs from '../assets/p-cards/K_of_clubs.png';
import p_kingOfSpades from '../assets/p-cards/K_of_spades.png';
import p_aceOfHearts from '../assets/p-cards/A_of_hearts.png';
import p_aceOfDiamonds from '../assets/p-cards/A_of_diamonds.png';
import p_aceOfClubs from '../assets/p-cards/A_of_clubs.png';
import p_aceOfSpades from '../assets/p-cards/A_of_spades.png';


// ========== Background Images ==========
import footerBG from '../assets/footerBG.png';
import mainPopupBG from '../assets/main-popup-background.png';


export const commonIcons = {
  userIcon,
  exitIcon,
  exitIconN,
  textIcon,
  settingsIcon,
  soundIcon,
  soundOffIcon,
  plusIcon,
  arrowIcon,
  dropdownBackground,
  qrScanIcon,
  copyIcon,
  editIcon,
  eyeIcon,
  checkmarkIcon,
  replayIcon,

  playerCardBg,
  homeCardBg,
  buttonBg,
  playerAvatarBg,

  dealerIcon,
  scoreIcon,
  tokenRed,
  tokenYellow,
  tokenGreen,
  standardBet,
  betPro,
  betFree,
  betExpert,
  sliderHandle,

  endGameBg,
  endGameBgWin,
  endGameBgX,

  usdtIcon,
  usdtSvg,
  starIcon,
  trxIcon,
  tonIcon,
  telegramIcon,

  hearts,
  diamonds,
  clubs,
  spades,
  anxoz,

  trpOn,
  trp
};


export const gameLogos = {
  rps: rpsLogo,
  blot: blotLogo,
  carrom: carromLogo,
  backgammon: backgammonLogo,
  poker: pokerLogo,
  domino: dominoLogo
};



export const homeAssets = {
  medal,
  home,
  coins,
  tasks,
  friends,
  trophy,
  avatarIcon,
  more,
  smile,
  gameCard,
  settingIcon
};



export const blotAssets = {
  cardBack,
  cards: {
    '7_of_hearts': sevenOfHearts,
    '7_of_diamonds': sevenOfDiamonds,
    '7_of_clubs': sevenOfClubs,
    '7_of_spades': sevenOfSpades,
    '8_of_hearts': eightOfHearts,
    '8_of_diamonds': eightOfDiamonds,
    '8_of_clubs': eightOfClubs,
    '8_of_spades': eightOfSpades,
    '9_of_hearts': nineOfHearts,
    '9_of_diamonds': nineOfDiamonds,
    '9_of_clubs': nineOfClubs,
    '9_of_spades': nineOfSpades,
    '10_of_hearts': tenOfHearts,
    '10_of_diamonds': tenOfDiamonds,
    '10_of_clubs': tenOfClubs,
    '10_of_spades': tenOfSpades,
    'J_of_hearts': jackOfHearts,
    'J_of_diamonds': jackOfDiamonds,
    'J_of_clubs': jackOfClubs,
    'J_of_spades': jackOfSpades,
    'Q_of_hearts': queenOfHearts,
    'Q_of_diamonds': queenOfDiamonds,
    'Q_of_clubs': queenOfClubs,
    'Q_of_spades': queenOfSpades,
    'K_of_hearts': kingOfHearts,
    'K_of_diamonds': kingOfDiamonds,
    'K_of_clubs': kingOfClubs,
    'K_of_spades': kingOfSpades,
    'A_of_hearts': aceOfHearts,
    'A_of_diamonds': aceOfDiamonds,
    'A_of_clubs': aceOfClubs,
    'A_of_spades': aceOfSpades
  }
};



export const pokerAssets = {
  cardBack,
  chipRed,
  cards: {
    '2_of_hearts': p_twoOfHearts,
    '2_of_diamonds': p_twoOfDiamonds,
    '2_of_clubs': p_twoOfClubs,
    '2_of_spades': p_twoOfSpades,
    '3_of_hearts': p_threeOfHearts,
    '3_of_diamonds': p_threeOfDiamonds,
    '3_of_clubs': p_threeOfClubs,
    '3_of_spades': p_threeOfSpades,
    '4_of_hearts': p_fourOfHearts,
    '4_of_diamonds': p_fourOfDiamonds,
    '4_of_clubs': p_fourOfClubs,
    '4_of_spades': p_fourOfSpades,
    '5_of_hearts': p_fiveOfHearts,
    '5_of_diamonds': p_fiveOfDiamonds,
    '5_of_clubs': p_fiveOfClubs,
    '5_of_spades': p_fiveOfSpades,
    '6_of_hearts': p_sixOfHearts,
    '6_of_diamonds': p_sixOfDiamonds,
    '6_of_clubs': p_sixOfClubs,
    '6_of_spades': p_sixOfSpades,
    '7_of_hearts': p_sevenOfHearts,
    '7_of_diamonds': p_sevenOfDiamonds,
    '7_of_clubs': p_sevenOfClubs,
    '7_of_spades': p_sevenOfSpades,
    '8_of_hearts': p_eightOfHearts,
    '8_of_diamonds': p_eightOfDiamonds,
    '8_of_clubs': p_eightOfClubs,
    '8_of_spades': p_eightOfSpades,
    '9_of_hearts': p_nineOfHearts,
    '9_of_diamonds': p_nineOfDiamonds,
    '9_of_clubs': p_nineOfClubs,
    '9_of_spades': p_nineOfSpades,
    '10_of_hearts': p_tenOfHearts,
    '10_of_diamonds': p_tenOfDiamonds,
    '10_of_clubs': p_tenOfClubs,
    '10_of_spades': p_tenOfSpades,
    'J_of_hearts': p_jackOfHearts,
    'J_of_diamonds': p_jackOfDiamonds,
    'J_of_clubs': p_jackOfClubs,
    'J_of_spades': p_jackOfSpades,
    'Q_of_hearts': p_queenOfHearts,
    'Q_of_diamonds': p_queenOfDiamonds,
    'Q_of_clubs': p_queenOfClubs,
    'Q_of_spades': p_queenOfSpades,
    'K_of_hearts': p_kingOfHearts,
    'K_of_diamonds': p_kingOfDiamonds,
    'K_of_clubs': p_kingOfClubs,
    'K_of_spades': p_kingOfSpades,
    'A_of_hearts': p_aceOfHearts,
    'A_of_diamonds': p_aceOfDiamonds,
    'A_of_clubs': p_aceOfClubs,
    'A_of_spades': p_aceOfSpades
  }
};


export const rpsAssets = {
  rock,
  paper,
  scissors,
  stars
};



export const carromAssets = {
  boardBackground,
  boardBorder,
  boardLines,
  striker,
  whiteCoin,
  blackCoin,
  queenCoin,
  whiteCoinS,
  blackCoinS,
  queenCoinS,
  star,
  controller
};



export const backgammonAssets = {
  board,
  checkerwhite,
  checkerblack,
  dice: [dice1, dice2, dice3, dice4, dice5, dice6],
  opponentDice: [opponentDice1, opponentDice2, opponentDice3, opponentDice4, opponentDice5, opponentDice6],
  voidButton,
  confirmButton,
  rollDiceButton,
  waitingButton,
  moveBlocked,
  whiteCheckerX,
  blackCheckerX
};


export const backgroundImages = {
  footerBG,
  mainPopupBG
};

// ========== Flags ==========
export const getFlag = (countryCode) => {
  try {
    return require(`../assets/flags/${countryCode.toLowerCase()}.svg`);
  } catch (err) {
    console.error(`Missing flag: ${countryCode}`);
    return null;
  }
};

// ========== Helper Functions ==========
export const preloadAssets = async (assets) => {
  const loadAsset = (src) => {
    return new Promise((resolve) => {
      if (!src) {
        console.warn('Undefined asset path, skipping preload');
        resolve();
        return;
      }
      const img = new Image();
      img.src = typeof src === 'string' ? src : src.default || src;
      img.onload = resolve;
      img.onerror = () => {
        console.warn(`Failed to preload asset: ${src}`);
        resolve();
      };
      
    });
    
  };

  const timeout = new Promise(resolve => setTimeout(resolve, 3000));

  try {
    await Promise.race([
      Promise.all(assets.map(loadAsset)),
      timeout
    ]);
  } catch (error) {
    console.error('Asset preloading error:', error);
  }
};

export const welcomeAssets = {
  welcome1: welcomeImage1,
  welcome2: welcomeImage2,
  welcome3: welcomeImage3,
  welcome4: welcomeImage4,
  welcome5: welcomeImage5,
};

export const getAssetPaths = (gameMode) => {
  const commonAssets = [
    commonIcons.settingsIcon,
    commonIcons.textIcon,
    commonIcons.soundIcon,
    commonIcons.soundOffIcon,
    commonIcons.exitIcon,
    commonIcons.exitIconN,
  ];

  switch(gameMode) {
    case 'blot': 
      return [
        ...commonAssets,
        blotAssets.cardBack,
        ...Object.values(blotAssets.cards),
        commonIcons.hearts,
        commonIcons.diamonds,
        commonIcons.clubs,
        commonIcons.spades,
        commonIcons.anxoz
      ];
    case 'rps': 
      return [
        ...commonAssets,
        rpsAssets.rock,
        rpsAssets.paper,
        rpsAssets.scissors
      ];
    case 'carrom': 
      return [
        ...commonAssets,
        carromAssets.boardBackground,
        carromAssets.boardBorder,
        carromAssets.boardLines,
        carromAssets.striker,
        carromAssets.whiteCoin,
        carromAssets.blackCoin,
        carromAssets.queenCoin
      ];
    case 'backgammon': 
      return [
        ...commonAssets,
        backgammonAssets.board,
        backgammonAssets.checkerwhite,
        backgammonAssets.checkerblack,
        ...backgammonAssets.dice,
        ...backgammonAssets.opponentDice,
        backgammonAssets.voidButton,
        backgammonAssets.confirmButton
      ];
      case 'poker': 
      return [
        ...commonAssets,
        pokerAssets.cardBack,
        ...Object.values(pokerAssets.cards),
        commonIcons.hearts,
        commonIcons.diamonds,
        commonIcons.clubs,
        commonIcons.spades,
        commonIcons.anxoz
      ];
      case 'domino': 
      return [
        ...commonAssets,
        blotAssets.cardBack,
        ...Object.values(blotAssets.cards),
        commonIcons.hearts,
        commonIcons.diamonds,
        commonIcons.clubs,
        commonIcons.spades,
        commonIcons.anxoz
      ];
    default: 
      return commonAssets;
  }
};